import Quill from 'quill';
import ToolbarModule from 'quill/modules/toolbar';

import { COMMENT_ATTACHMENT_MAX_FILE_SIZE, COMMENT_INLINE_IMAGE_ALLOWED_TYPES } from '../comments.utils';

export class ImageUploadQuillModule {
  private quill: Quill;
  private fileInput: HTMLInputElement | null = null;
  private savedIndex = 0;
  private destroyed = false;

  public onImageSelected?: (file: File, insertImage: (url: string) => void) => void;
  public onImageRejected?: (file: File, reason: 'type' | 'size') => void;

  constructor(quill: Quill) {
    this.quill = quill;
    this.createFileInput();
    this.overrideToolbarHandler();
  }

  private overrideToolbarHandler(): void {
    const toolbar = this.quill.getModule('toolbar') as ToolbarModule;
    if (!toolbar) return;

    toolbar.addHandler('image', () => {
      this.savedIndex = this.quill.getSelection(true)?.index ?? this.quill.getLength();
      this.fileInput?.click();
    });
  }

  private createFileInput(): void {
    this.fileInput = document.createElement('input');
    this.fileInput.type = 'file';
    this.fileInput.accept = COMMENT_INLINE_IMAGE_ALLOWED_TYPES.join(',');
    this.fileInput.style.display = 'none';
    this.fileInput.addEventListener('change', () => {
      const file = this.fileInput?.files?.[0];
      if (!file) return;

      // Reset so the same file can be selected again
      this.fileInput!.value = '';

      if (!COMMENT_INLINE_IMAGE_ALLOWED_TYPES.includes(file.type)) {
        this.onImageRejected?.(file, 'type');
        return;
      }

      if (file.size > COMMENT_ATTACHMENT_MAX_FILE_SIZE) {
        this.onImageRejected?.(file, 'size');
        return;
      }

      if (this.onImageSelected) {
        const insertIndex = this.savedIndex;
        this.onImageSelected(file, (url: string) => {
          if (this.destroyed) return;
          this.quill.insertEmbed(insertIndex, 'image', url, Quill.sources.USER);
          this.quill.setSelection(insertIndex + 1, 0);
        });
      }
    });
    document.body.appendChild(this.fileInput);
  }

  destroy(): void {
    this.destroyed = true;
    this.fileInput?.remove();
  }
}
